import { P2GChip } from '@parcel2go/core-ui';

interface props {
  label: string;
  color?: 'primary' | 'secondary' | 'default' | 'success' | 'error' | 'info' | 'danger' | 'warning';
}

export default function Tag(props: props) {
  if (props.label === 'ReturnCollection') {
    return <P2GChip color="primary" size="small" label={'Return Collection'} />;
  }

  if (props.label === 'CLAIM') {
    return <P2GChip color="warning" size="small" label={'Claim'} />;
  }

  if (props.label === 'REFUND') {
    return <P2GChip color="success" size="small" label={'Refunded'} />;
  }

  return <P2GChip color={props.color || 'primary'} size="small" label={props.label} />;
}
